<template>
  <v-app>
    <v-snackbar v-model="snackbar" ref="snackBar">
      {{ msg }}
      <v-btn dark text @click="snackbar = false">Close</v-btn>
    </v-snackbar>
    <v-content class="fluid fill-height">
      <v-stepper v-model="e1" class="elevation-0 fill-height">
        <v-stepper-header class="elevation-0">
          <v-stepper-step :editable="true" :complete="e1 > 1" step="1"
            >Dados do Psicólogo</v-stepper-step
          >
          <v-divider></v-divider>
          <v-stepper-step :editable="true" step="2">Áreas de Atuação</v-stepper-step>
        </v-stepper-header>

        <v-stepper-items>
          <v-stepper-content step="1">
            <v-row class="align-center justify-center">
              <v-col class="col-4 ma-0 pa-0">
                <ButtonFoto
                  title="Foto de Perfil"
                  v-bind:email="email"
                  v-on:url-img="saveImgProfile"
                  folder="psicologo"
                  name_img="profileImg"
                />
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-4 ma-0 pa-0">
                <v-text-field
                  solo
                  flat
                  label="URL pública"
                  v-model="slug"
                  :rules="slugRules"
                  :error="slugError"
                  :success="slugSuccess"
                  :error-messages="errorSlugMessage"
                  :success-messages="successSlugMessage"
                  v-debounce:600="verifySlug"
                  required
                  maxlength="25"
                  background-color="#F7F7F7"
                >
                  <p slot="prepend">{{ url }}/psicologo/</p>
                </v-text-field>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-10 col-lg-8">
                <p class="text-center caption">
                  <b
                    >O campo acima serve para criarmos um link do seu perfil para o público. Sua
                    URL: {{ url }}/psicologo/{{ slug | slugify }}</b
                  >
                </p>
              </v-col>
            </v-row>
            <v-row class="align-center justify-center">
              <v-col class="col-12 col-md-12">
                <v-form v-model="valid2" ref="form">
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nome Completo"
                          v-model="name"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-select
                          :items="list_gender"
                          v-model="gender"
                          label="Sexo"
                          @change="getGender"
                          :rules="rules"
                          required
                          solo
                          flat
                          background-color="#F7F7F7"
                        ></v-select>

                        <v-text-field
                          filled
                          flat
                          label="Habilitações Académicas"
                          placeholder="Sou douturanda e tenho dois mestrados na área de ansiedade infantil."
                          v-model="academic_degree"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-row>
                          <v-col class="col-4 py-0">
                            <v-text-field
                              id="symbolMoney"
                              filled
                              flat
                              disabled
                              v-if="language === 'pt'"
                              label="€"
                              background-color="#F7F7F7"
                            ></v-text-field>
                            <v-text-field
                              id="symbolMoney"
                              filled
                              flat
                              disabled
                              v-if="language === 'pt-BR'"
                              label="R$"
                              background-color="#F7F7F7"
                            ></v-text-field>
                          </v-col>
                          <v-col class="col-8 py-0">
                            <money v-model="price" v-bind="money"></money>
                          </v-col>
                        </v-row>
                      </v-col>
                      <v-col class="col-12 col-sm-6 col-md-4">
                        <v-text-field
                          solo
                          flat
                          label="Nacionalidade"
                          v-model="nation"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-autocomplete
                          solo
                          flat
                          hide-no-data
                          clearable
                          label="Fuso horário"
                          v-model="time_zone_name"
                          :items="time_zone"
                          :rules="rules"
                          @change="timeZone"
                          item-value="timezone"
                          item-text="timezone"
                          required
                          background-color="#F7F7F7"
                        >
                          <template v-slot:item="data">
                            <template v-if="typeof data.item !== 'object'">
                              <v-list-item-content v-text="data.item"></v-list-item-content>
                            </template>
                            <template v-else>
                              <v-list-item-content>
                                <v-list-item-title v-html="data.item.timezone"></v-list-item-title>
                              </v-list-item-content>
                            </template>
                          </template>
                        </v-autocomplete>
                        <v-text-field
                          solo
                          flat
                          label="Cidade"
                          v-model="city"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-text-field
                          solo
                          flat
                          :label="$t('pageCadastro.labelDestrito')"
                          v-model="state"
                          :rules="rules"
                          required
                          background-color="#F7F7F7"
                        ></v-text-field>
                        <v-textarea
                          solo
                          flat
                          :label="$t('pageEditProfile.psiBio')"
                          v-model="biography"
                          background-color="#F7F7F7"
                          counter
                          maxlength="3000"
                          hint="Atenção: Limite de 3000 caracteres."
                        ></v-textarea>
                      </v-col>
                    </v-row>
                    <v-row class="flex-column align-center justify-center">
                      <v-btn
                        class="my-5"
                        color="secondary"
                        depressed
                        large
                        @click="e1 = 2"
                        :disabled="!valid2 || slugError"
                        >CONTINUAR</v-btn
                      >
                      <v-btn text to="profile">Cancelar</v-btn>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
          </v-stepper-content>

          <v-stepper-content step="2">
            <v-row class="align-center justify-center">
              <v-col class="col-12">
                <v-form>
                  <v-container>
                    <v-row class="justify-center">
                      <v-col class="col-12 col-sm-8">
                        <h2 class="primary--text">Áreas de Atuação</h2>
                        <p class="font-italic">Selecione uma ou mais áreas.</p>
                        <v-row row wrap>
                          <v-col
                            class="shrink pa-1 col-auto"
                            v-for="(especiality, index) in types"
                            :key="index"
                          >
                            <v-checkbox
                              class="specialities"
                              v-model="selected"
                              :value="especiality.id"
                              :label="especiality.description"
                            ></v-checkbox>
                          </v-col>
                        </v-row>
                      </v-col>
                    </v-row>
                  </v-container>
                </v-form>
              </v-col>
            </v-row>
            <v-row class="flex-column align-center justify-center">
              <v-btn
                class="mb-2"
                color="secondary"
                depressed
                large
                @click="submit"
                :loading="loader"
                >{{ $t('pageEditProfile.btnSalvar') }}</v-btn
              >
              <v-btn text to="profile">Cancelar</v-btn>
            </v-row>
          </v-stepper-content>
        </v-stepper-items>
      </v-stepper>
    </v-content>
  </v-app>
</template>

<script>
import Vue from 'vue';
import ct from 'countries-and-timezones';
import { Money } from 'v-money';

import ButtonFoto from '@/components/ButtonFoto';

import Api from '../../services/httpClient';
import { checkPsychologistSlug } from '../../services/psychologists';
import getLanguage from '../../utils/getLanguage';
import {
  getAllCountriesTimezones,
  getTimezoneFormattedWithCountry,
} from '../../utils/getTimezones';

export default {
  components: {
    ButtonFoto,
    Money,
  },
  data() {
    return {
      language: null,
      slugError: null,
      slugSuccess: null,
      errorSlugMessage: [],
      successSlugMessage: [],
      slug: '',
      slugRules: [(v) => !!v || 'O campo é obrigatório'],
      valid: false,
      valid2: false,
      loader: false,
      show1: false,
      show2: false,
      e1: 1,
      photo_profile: '',
      name: '',
      list_gender: ['Masculino', 'Feminino', 'Outros'],
      gender: '',
      // list_symbol: ['R$', '€'],
      list_symbol: ['€'],
      symbol: '',
      url: '',
      date: '',
      date_birth: null,
      academic_degree: '',
      biography: '',
      nation: '',
      city: '',
      state: '',
      opp: '',
      photo_opp_front: '',
      photo_opp_back: '',
      price: '',
      money: {
        precision: 2,
        masked: false,
      },
      time_zone: [],
      time_offset: '',
      time_zone_name: '',
      email: '',
      password: '',
      check_password: '',
      checkbox: false,
      rules: [(v) => !!v || 'Esse campo é obrigatório'],
      snackbar: false,
      msg: '',
      menu: false,
      types: [],
      selected: [],
      cod: '',
      page: 1,
    };
  },

  mounted() {
    this.language = getLanguage(window.location.href);
    this.time_zone = getAllCountriesTimezones();
  },

  async created() {
    this.getCod();
    await this.getProfile();
    this.getSpecialities();
    this.symbol = this.language === 'pt' ? '€' : 'R$';
    this.url = this.language === 'pt' ? 'ondivan.net' : 'ondivan.com.br';
  },

  methods: {
    timeZone(val) {
      const timezoneInfo = val.split('-');
      const [timezone] = timezoneInfo;
      const countryTimezone = ct.getTimezone(timezone.trim());
      this.time_offset = countryTimezone.utcOffsetStr;
      this.time_zone_name = val;
    },
    getGender(v) {
      this.gender = v;
    },
    getLanguage(v) {
      this.language = v;
    },
    getSymbol(v) {
      this.symbol = v;
    },

    async submit() {
      if (this.$refs.form.validate()) {
        this.loader = true;
        await this.editProfile();
      }
    },

    editProfile() {
      const timezone = this.time_zone_name.split('-');
      const [timezoneName] = timezone;
      let appointment_br_value = '0';
      let appointment_pt_value = '0';
      if (this.symbol == 'R$') {
        appointment_br_value = this.price;
      } else if (this.symbol == '€') {
        appointment_pt_value = this.price;
      }
      Api.patch(
        `/psychologists/${this.cod}/`,
        {
          name: this.name,
          gender: this.gender,
          academic_degree: this.academic_degree,
          biography: this.biography,
          country: this.nation,
          slug: this.slug,
          city: this.city,
          state: this.state,
          photo: this.photo_profile,
          time_zone: this.time_offset,
          time_zone_name: timezoneName,
          appointment_br_value,
          appointment_pt_value,
        },
        {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        },
      )
        .then((response) => {
          Api.post(
            `/psychologists/${response.data.id}/specialities/`,
            {
              id: this.selected,
            },
            {
              headers: {
                Authorization: `Token ${localStorage.getItem('user-token')}`,
              },
            },
          )
            .then((res) => {
              this.msg = 'Atualização realizado com sucesso!';
              this.snackbar = true;
              setTimeout(() => {
                this.$router.replace('/psicologo/profile');
              }, 3000);
            })
            .catch((err) => {
              console.log(err);
            });
        })
        .catch((e) => {
          console.log(e.response.data);
          if (e.response.data.email) {
            this.snackbar = true;
            this.msg = e.response.data.email;
          }
          if (e.response.data.appointment_br_value || e.response.data.appointment_pt_value) {
            this.snackbar = true;
            this.msg = e.response.data.appointment_br_value
              ? e.response.data.appointment_br_value[0]
              : e.response.data.appointment_pt_value[0];
          }
        })
        .finally(() => (this.loader = false));
    },

    getSpecialities() {
      Api.get('/specialities/', {
        params: {
          page: this.page,
        },
      }).then((res) => {
        const { results, next } = res.data;
        for (const item of results) {
          this.types.push(item);
        }
        if (next != null) {
          this.page = this.page + 1;
          this.getSpecialities();
        }
      });
    },

    async verifySlug() {
      const slug = Vue.filter('slugify')(this.slug);
      try {
        await checkPsychologistSlug(slug);
        this.slugError = true;
        this.slugSuccess = false;
        this.errorSlugMessage[0] = 'Esta URL final já exsite. Por favor, escolha outra.';
        this.successSlugMessage = [];
      } catch (error) {
        this.slugError = false;
        this.slugSuccess = true;
        this.errorSlugMessage = [];
        this.successSlugMessage[0] = 'Esta URL final está válida!';
      }
    },

    getProfile() {
      Api.get(`/psychologists/${this.cod}/`, {
        headers: {
          Authorization: `Token ${localStorage.getItem('user-token')}`,
        },
      }).then((response) => {
        const user = response.data;
        // console.log(response.data);

        this.name = user.name;
        this.email = user.email;
        this.gender = user.gender;
        this.academic_degree = user.academic_degree;
        this.biography = user.biography;
        this.nation = user.country;
        this.city = user.city;
        this.slug = user.slug;
        this.state = user.state;
        this.photo_profile = user.photo;
        this.time_offset = user.time_zone;
        this.time_zone_name = getTimezoneFormattedWithCountry(user.time_zone_name);
        this.price =
          user.appointment_br_value == 0 ? user.appointment_pt_value : user.appointment_br_value;
        this.symbol = user.appointment_br_value == 0 ? '€' : 'R$';

        Api.get(`/psychologists/${this.cod}/specialities`, {
          headers: {
            Authorization: `Token ${localStorage.getItem('user-token')}`,
          },
        }).then((response) => {
          for (const item of response.data) {
            this.selected.push(item.id);
          }
        });
      });
    },

    getCod() {
      this.cod = localStorage.getItem('user-id');
    },

    saveImgProfile(value) {
      this.photo_profile = value;
    },
  },
};
</script>

<style scoped>
* >>> .specialities {
  margin-top: 0px;
}

* >>> .specialities .v-input--selection-controls__input {
  display: none;
}

* >>> .specialities.v-input--selection-controls:not(.v-input--hide-details) .v-input__slot {
  margin-bottom: 0;
  background: #ffffff;
  border: 2px solid #02a554;
  padding: 8px 16px;
  border-radius: 23px;
}
* >>> .specialities.v-input--selection-controls.v-input .v-label {
  color: #02a554;
}
* >>> .specialities.v-input--is-label-active .v-input__control .v-input__slot {
  background: #02a554;
}

* >>> .specialities.v-input--is-label-active.v-input--selection-controls.v-input .v-label {
  color: #ffffff;
}

* >>> .v-input__slot:after {
  display: none;
}

* >>> .v-input__slot:before {
  display: none;
}
.v-money {
  height: 48px;
  width: 100%;
  background-color: rgb(247, 247, 247);
  border-radius: 4px;
  padding: 10px;
  caret-color: #93291e;
}
.v-money:focus {
  outline-offset: unset;
  outline: none;
}
</style>
